import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import WorkIcon from '@mui/icons-material/Work';

function Contact() {

  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const [sending, setSending] = useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [sendMsg, setSendMsg] = useState<string>('');

  const form = useRef();

  const sendEmail = async (e: any) => {
    e.preventDefault();

    setNameError(name.trim() === '');
    setEmailError(email.trim() === '');
    setMessageError(message.trim() === '');

    if (name.trim() === '' || email.trim() === '' || message.trim() === '') {
      setSendMsg('Please complete all required fields.');
      setSent(false);
      return;
    }

    setSending(true);
    setSendMsg('');

    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      setSending(false);
      setSendMsg('Email service not configured. Please set REACT_APP_EMAILJS_* env variables.');
      setSent(false);
      return;
    }

    try {
      const templateParams = {
        from_name: name,
        reply_to: email,
        message: message,
        company: 'The Project Genesis Company',
      };

      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);

      setSending(false);
      setSent(true);
      setSendMsg('Message sent — thank you! We will reply shortly.');
      setName('');
      setEmail('');
      setMessage('');
      setTimeout(() => setSent(false), 5000);
    } catch (err) {
      console.error('EmailJS error', err);
      setSending(false);
      setSent(false);
      setSendMsg('Send failed — please try again later.');
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact The Project Genesis LLC</h1>
          <p className="lead">For LLC or CEO enquiries, contact us using the form below or via the details provided.</p>

          <div className="contact-grid">
            <aside className="contact-info" aria-label="Contact information">
              <p className="company-line"><strong>The Project Genesis LLC</strong> — CEO: Dr. Jonathan Rann</p>
              <div className="info-items">
                <a href="mailto:jCheshireRann@gmail.com" target="_blank" rel="noreferrer"><MailIcon/> <span>jCheshireRann@gmail.com</span></a>
                <a href="tel:336-575-5961" target="_blank" rel="noreferrer"><PhoneIcon/> <span>336-575-5961</span></a>
                <a href="https://github.com/genesis-solution" target="_blank" rel="noreferrer"><GitHubIcon/> <span>GitHub</span></a>
                <a href="https://www.linkedin.com/in/jonathan-rann" target="_blank" rel="noreferrer"><LinkedInIcon/> <span>LinkedIn</span></a>
                <a href="https://www.guru.com/freelancers/genesis-solutions" target="_blank" rel="noreferrer"><WorkIcon/> <span>Guru</span></a>
              </div>
              {/* <a className="cv-download" href="/Resume%20(2025)%20-%20Dr%20Jonathan%20Rann%20-%20Full%20Stack%20Developer%20and%20Data%20Scientist.pdf" target="_blank" rel="noreferrer">Download CV</a> */}
              <p className="blurb">We build web apps, data platforms and production ML systems. Tell us about your project and we'll provide a tailored proposal.</p>
            </aside>

            <div className="contact-form-wrapper">
              <Box
                ref={form}
                component="form"
                noValidate
                autoComplete="off"
                className='contact-form'
              >
                <div className='form-flex'>
                  <TextField
                    required
                    id="outlined-name"
                    label="Your Name"
                    placeholder="What's your name?"
                    value={name}
                    onChange={(e) => { setName(e.target.value); }}
                    error={nameError}
                    helperText={nameError ? "Please enter your name" : ""}
                    fullWidth
                  />
                  <TextField
                    required
                    id="outlined-contact"
                    label="Email / Phone"
                    placeholder="How can I reach you?"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); }}
                    error={emailError}
                    helperText={emailError ? "Please enter your email or phone number" : ""}
                    fullWidth
                  />
                </div>
                <TextField
                  required
                  id="outlined-multiline-static"
                  label="Message"
                  placeholder="Send me any inquiries or questions"
                  multiline
                  rows={10}
                  className="body-form"
                  value={message}
                  onChange={(e) => { setMessage(e.target.value); }}
                  error={messageError}
                  helperText={messageError ? "Please enter the message" : ""}
                  fullWidth
                />
                <div className="form-actions">
                  <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail} disabled={sending}>
                    {sending ? 'Sending...' : 'Send Message'}
                  </Button>
                  {sendMsg && <div className={`send-msg ${sent ? 'success' : 'error'}`}>{sendMsg}</div>}
                </div>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;